export default "__VITE_ASSET___24u705S__"